// extracted by mini-css-extract-plugin
export default {"card":"cardteacher_card__RuX3k","teacher":"cardteacher_teacher__BxgGr","selected":"cardteacher_selected__Zq6z5"};